import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./Instructions.css";
import instructionsImg from "../../../img/test-images/intro-images/instructions.svg";

function Instructions() {
  return (
    <div className="instructions-div">
      <Container className="instructions-container">
        <h2>Instructions</h2>
        <Row>
          <Col md={6}>
            {/* <p>
               For example, ‘breaking of
              friendships’, ‘passing an exam’ etc. Read each statement
              carefully. Respond only to the events which have occurred in your
              life since the last one year.
            </p> */}
            <p>
              The next few pages describe some events and situations which occur
              frequently in a student's life.
            </p>
            <p>
              <strong>
                If the events have not occurred in the past one year, click
                "Does Not Apply".
              </strong>
            </p>
            <p>
              <strong>
                If they have, click the option that best describes the degree of
                stress you've experienced.
              </strong>
            </p>
            <p>Your responses will be kept strictly confidential.</p>
            <br />
            <Button
              variant="secondary"
              size="lg"
              href="/selfevaluation/stress-scale/quiz"
            >
              Begin
            </Button>
          </Col>
          <Col md={6}>
            <img src={instructionsImg} alt="instructions" className="instructions-img" />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Instructions;
